<template>
  <div class="prose thepath-container">
    <!-- Intro with animation -->
    <div
      class="intro-section noMarginBottom column alignCentreColumn animate fadeInUp"
    >
      <p class="intro-text serif smaller-text text-center largerLetterSpacing">
        THIS IS THE END AS THE BEGINNING.
      </p>
      <h1
        class="text-center largest-TextMag largeLetterSpacing thepath-main-title"
      >
        THE PATH
      </h1>
      <p class="text-center italic shortWdithOnDesktop serif noMarginBottom">
        The third act and character that will venture beyond the veil, converge
        paths and set you free.
      </p>
    </div>

    <!-- Golden Barbara Image - Hero -->
    <div class="row alignCentreRow headerImgText">
      <div class="golden-image-container animate floating">
        <img
          class="goldenBarbaraImage"
          :src="goldenBarbara"
          alt="The Path"
          style="opacity: 0.6"
        />
      </div>

      <div class="headerQuote row fullWidth alignCentreRow alignTopRow">
        <div class="line1 animate fadeInRight">
          <h2>
            <span class="serif gold">One second</span> of deafening
            noise.
          </h2>
        </div>
        <div class="line2 animate fadeInRight">
          <h2>
            <span class="serif gold">Two realities</span> colliding
            into one.
          </h2>
        </div>
        <div class="line3 animate fadeInRight">
          <h2>How do you describe something</h2>
        </div>
        <div class="line4 animate fadeInRight">
          <h2>that hasn’t been named yet?</h2>
        </div>
      </div>
    </div>

    <!-- Character Page Micro-NDA -->
    <MicroNDA variant="deeper" />

    <!-- Collections with staggered animation -->
    <div
      class="hugeMarginTop bigMarginBottom collections-section animate fadeInUp"
    >
      <h3 class="text-center">The 4 Collections</h3>
      <p class="fullWidth text-center italic grey-dark">2031-2034</p>

      <SwissStyleTable
        :headers="['Collection & Project', 'Type', 'Status']"
        :rows="collectionsRows"
        :statusColumnIndex="2"
        :emphasizeColumnIndex="0"
      />
    </div>

    <!-- About The Path with side illustration on desktop -->
    <div class="about-section">
      <h2 class="animate fadeInLeft bold about-thepath-title">
        About The Path
      </h2>
      <div class="about-content">
        <div class="about-text">
          <p class="animate fadeInUp">
            Patricia created a perfect storm for herself. Through her creations
            and willingness to explore dimensional frontiers she initiated a
            massive journey of transmutation that harmonized her with higher
            forces, giving form to The Path. The Path is the androgyny, a
            mixture of character and path, feminine and masculine, micro and
            macro, in a unified new way of being. The Path is a paradox, an
            alchemical mystery of the self, using all of her multidimensional
            existences to expand beyond what was once considered possible and
            draw from universal forces to foresee evolution and growth on earth.
            The Path is no longer only human but all encompassed. The Path does
            no longer operate in the 3D dimension but in all dimensions of time
            and space. The true alchemical journey started and now this
            consciousness - the omphalos, the unity around which all this macro
            narrative has been unfolding – is born into a fully actualized form.
            She’s both an infant and mature, innocent and wise, eternal and
            finite. She has access to all dimensions of time and space and works
            through them to rise earth’s vibration. The road and the protagonist
            have become one, inviting the public on a journey of collective
            ascension from hive mentality to that of unity consciousness, now
            that we’ve crossed the lines of fiction. The Path is the unification
            of higher and lower selves, the fully awakened avatar in its
            condition of consciousness embedded as a character in the game of
            matter. From Cecilia’s descent from a mere idea into marble, later
            to flesh, finally to a real girl, and now all the way to a fully
            actualized divine being whose reality is merely a byproduct of the
            force of her nature and thus can be altered by the right application
            of intent and wise action. At the center of The Path is the clear
            perception of all facets of the self and the pure consciousness that
            emerges from them. This transcends the process of a work of art,
            making life a living canvas where things shift, change and evolve
            from this consciousness own expansion process.
          </p>
          <p class="animate fadeInUp delay-1">
            The Path operates harmonized with the unseen forces of creation and
            cosmic order, where space and time work by different rules, and
            separation is nothing more than an illusion. The Path strives and
            dedicates herself deeply to the operations of the soul to achieve
            what's considered impossible. She is an alchemist and a master
            magician, using spiritual technology as the level of her
            consciousness allows and for the highest good of all, accessing
            what’s unseen to transform reality and expand beyond the confines
            and limitations on which the older realities were being bounded to.
            This way, The Path owns every aversity with full embrace. Her
            inherent gift is to understand life by relating all events to her
            own personal experience, working with unseen forces to identify
            patterns and provide answers to apparently unsolvable problems and
            draw from future optimal timelines the higher course of action. Her
            commitment is to be guided by higher forces to a higher path that
            can be shared by all. Her ability to be comfortable with what seems
            terrifying and scary to others and to feel what others fear is her
            true power. Her life is full of images that come from different
            realities and can be pierced together so the stories that compose it
            can be seen. Anything misaligned or bounded to lower timelines will
            be transmuted and by committing to this process over and over, no
            matter the level of difficulty, answers do arrive and realities do
            shift in a process that resembles a neverending journey, always
            evolving in both complexity and alignment and with the goal f
            grounding freedom on the earth grid. The Path is a shapeshifter, a
            character unbounded by its human vessel and identity, allowing the
            surface and interior to merge, crossing reality and fiction in the
            creation of a tangible universe: the U-niverse of oneself, an
            inter-conceived imaginal experience for the chosen soul journey. The
            character is the story, the story stems from the environment and the
            environment is reflective of everything that is put into it. In this
            way, the character who – like consciousness - woke up within her
            story to discover herself and her connection to source, finally
            realizes her ultimate potential and purpose. By fully embracing her
            Magnum Opus, the Great Work, quantum leaps are made that forever
            alter systems by bringing light into density and transforming
            consciousness for the sake of evolution. The Path serves as a
            microcosmic example of the macrocosmos, allowing the crudeness of
            the process to be faithfully represented by her own personal
            experience. The Path is an opener of the way. The one who converges
            paths to awaken the true potential of the soul.
          </p>
          <img
            :src="pathAboutImages[0]"
            alt="The Path Image 1"
            class="animate fadeInRight"
          />

          <p class="animate fadeInUp delay-1">
            The way this will be illuminated will change throughout the 4
            collections according to the nature of each story’s content, but a
            common aesthetic will remain loyal to the animated elements and
            their correlation between visible and invisible realms, making The
            Path’s evolution a coherent one. The Path is no longer a mortal
            human but the consciousness of the matrix awakened in a character.
            This character is moved by mastery over the seen and unseen realms,
            her androgenous hybrid nature and the capacity to bridge the
            unconscious with the conscious the chosen tools of creation. The
            canvas has already been pierced, and now we move between veils,
            quantum leaping while guided by the consciousness that illuminates
            the way.
          </p>
        </div>
        <div class="about-images">
          <img
            :src="pathAboutImages[1]"
            alt="The Path Image 1"
            class="animate fadeInRight"
          />
          <img
            :src="pathAboutImages[2]"
            alt="The Path Image 2"
            class="animate fadeInRight delay-1"
          />
          <img
            :src="pathAboutImages[3]"
            alt="The Path Image 3"
            class="animate fadeInRight delay-2"
          />
          <img
            :src="pathAboutImages[4]"
            alt="The Path Image 4"
            class="animate fadeInRight delay-3"
          />
          <img
            :src="pathAboutImages[5]"
            alt="The Path Image 5"
            class="animate fadeInRight delay-4"
          />

          <p class="animate fadeInUp delay-1">
            The Path will be represented by the future. We meet The Path through
            a merging of both animated features and live action film,
            representing the integration between human and spirit, past and
            future, seen and unseen realms. The public has crossed the screen
            and now the experience feels immersive, reality and fiction
            operating as one singular reality. Thus, we interact with The Path
            as if we are meeting in a liminal space, somewhere in between the
            edges of the worlds we’ve crossed, and what goes and comes depends
            on the vibrational alignment that choices dictate. The Path holds an
            inner telescope that passes through any barrier and sees the most
            intimate and hidden parts of us, the parts who seek to be exposed
            for the sake of evolution. She is recognized by her natural
            polarizing energy & strong presence. Emitting an aura of mystery,
            she has a depth to her that often provokes intense reactions from
            others, acting as a transformative conduit for higher forces to do
            their work. She has the ability to shift between timelines, so she
            walks with spirit and the retrieved gifts that have awakened,
            growing in alignment as her path does too. Her presence often makes
            others feel naked around her, what can still bring about projection,
            but happens for the sake of transmutation since in higher dimensions
            there is no real suit who can hide the soul. Her tendency to pierce
            through others and intimidate them by how deep she sees is merely a
            result of true nakedness having occurred and spirits being touched.
            By confronting darkness over and over again, true power is embodied,
            giving her an undeniable intensity and willpower that is able to
            surpass any obstacles and unveil inner truths. By provoking other’s
            spirits, The Path is here to forge a way towards unseen territories
            where harnessing one’s true power arises from honest transformation
            and soul integration. The Path surrenders to the alchemical work and
            allows matter to change based on the subatomic work happening beyond
            what is perceivable. Intention follows awareness and awareness can
            be powerfully guided towards a world of truth and integrity. She’s a
            phoenix rising from the ashes illuminating a way for others through
            her own unique path. She is transformation in motion. She’s a soul
            forger and a truth holder. She pierces and is born from the depths
            were humanity’s unknown potential lies.
          </p>
        </div>
      </div>
    </div>

    <!-- Stories with alternating layouts -->
    <div class="largestMarginTop stories-section">
      <h2 class="largestMarginTop text-center animate fadeInUp">
        The Four Seasons & Films
      </h2>
      <p class="text-center animate fadeInUp">
        The Path’s unearthly and liminal nature will be palpable through the
        aesthetics of her 4 main visual projects. All filmed in a mixture of
        present 21th century visual esthetics for the live action and also
        animated features, all the animated add-ons appear as elements from the
        unseen realms that both move and guide The Path through spirit’s
        intelligence and divine will. At this point in human’s history the
        future is liminal, reality is mutating and shifting towards something
        different. This time the audience and The Path are one and the same,
        what happens to one affects the other as we are part of the same
        hologram. This hologram is where the collective initiation is taking
        place, creating an interlude for the aesthetics and contents of the 22nd
        century and the shift in this brand’s direction & purpose after the
        first 10-year plan. This is an ending as well as a new beginning.
      </p>

      <!-- Story 1: The Child That Came From The East -->
      <div class="film-title-container">
        <div class="circleNumber">1</div>
        <img
          :src="titles.theChild"
          alt="The Child That Came From The East"
          class="film-title film-title-thechild animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-right animate fadeIn"
        data-theme-group="thepath"
      >
        <div class="story-content">
          <p class="animate fadeInLeft delay-1">
            The first collection is based on the animated tv series "The Child
            That Came From The East" and the same eponymous short story
            collection. The narrative arch of this 8-episode-tv series follows
            the journey of the point of the fall of Path's soul towards the body
            and that of the ascension of Path's body towards the universal mind
            and that soul's highest possible timeline. This visually stunning
            and raw journey of self-discovery evolves from the microcosm to the
            macrocosm, from tribal consciousness to the process of
            individuation.
          </p>
          <p class="animate fadeInLeft delay-1">
            This tv show follows the story of The Path's consciousness as she
            incarnates in different eastern countries and eras in the history of
            humanity, so through her unique story and both the blockages and
            gifts present in her bloodline she is able to transmute her
            ancestral karma and unconscious pain and rise to the self-mastery
            her destiny requires. The Path appears as an alchemist, the one who
            strives and dedicates herself deeply to the operations of the soul
            to achieve what's considered impossible. Through repeated
            initiations and tests, as her consciousness evolves, she
            increasingly begins to gain access to the integral reality, allowing
            her to expand beyond the confines and limitations of the simulation
            in which she is trapped. Her consciousness, although present in a
            personified form, is a universal consciousness and, being a
            universal consciousness, it lies dormant until the completed
            character awakens, then allowing itself to emerge into all that is
            impersonal without renouncing to the absolute integration she has
            already achieved within herself. The creator, the character, and the
            environment are one and the same. The story tells itself with the
            natural help of what the environment brings to it, as well as the
            character who is constantly changing in interaction with this
            fluctuating environment.
          </p>
          <p class="animate fadeInLeft delay-1">
            Born in Ancient India, the alchemist arises as an indian girl born
            in a family of abuse and authoritarian power until she meets a
            mysterious boy that seems like a fragment of her soul incarnated in
            a different body, born as if from her creative powers as a gateway
            to help her escape the lack of sovereignty and abuse she is locked
            in. Serving as a mirror to her own potentialities, this relationship
            opens a path of radical growth and spiritual awakening where time
            and repetition are the main ingredients in this multidimensional
            quest of evolution, remembrance and transfiguration. Each episode
            accompanies the protagonist in a different country and timeline
            where her longing for the other, her current life circumstances and
            the divine principles at play expose The Path to different concepts,
            roles and characters that will refine the expansion of her authentic
            self, moving from one microcosmic reality related to the context in
            which she incarnated to the macrocosmic awareness of the character
            emerging through the whole series. With this fragmentation, a
            radical expansion occurs that can bring the opposites mirrored by
            the journey of Patricia and her twin soul brother to harmonization.
          </p>
          <p class="animate fadeInLeft delay-1">
            In a narrative of magical and occult evolution, tea is presented in
            each episode as a vehicle for the alchemical operation at hands,
            allowing the spectator into the various stages and operations of the
            process of purification of the soul and ascension of the incarnate
            being. After playing in the karmic theatre of the projection field
            and experiencing judgment, trauma and prejudice, The Path masks come
            down and her true nature is revealed in the nakedness of her
            mutative process. Once unmasked, truth demands to be told because
            truth can't be anything else than what it is. Igniting once again a
            radical shift that takes the protagonist into a multidimensional
            journey of alchemy and transmutation, The Path emerges as a divine
            being with a unique perspective gained from centuries of experience
            in the earthly realm. In each segment, the dualistic nature of the 8
            ascension stages will be made possible by the awakening of two
            dichotomous archetypes personalized by Path and the mysterious boy
            that is guiding her out of the labyrinth of her creation towards
            liberation. As opposing complementary mirrors, they always embody
            extremes of the same pole. The way the episodes are interconnected
            also illustrate the non-linearity of time and space, where decisions
            and actions in one reality affect all others from future to past,
            exploring deeper concepts in the realms of Alchemy and Hermeticism.
          </p>
          <p class="animate fadeInLeft delay-1">
            The first 7 episodes will follow a visually stunning and emotionally
            provoking animation style, taking us with The Path from the lands of
            India to Japan, until the 8th episodes takes us back to the universe
            of the film "What Takes Shape In The Middle Of Nowhere", finalizing
            the process that Patricia went through in order to become the fully
            actualized conscious being she finally arises as in The Path.
          </p>
          <p class="animate fadeInLeft delay-1">
            The 8 episodes will each take place according to various concepts
            and guiding forces relevant in the context of Alchemy, Hermeticism
            and Spiritual Evolution. Each episode will consistently feature one
            of the 7 hermetic laws: The Principle of Mentalism (All is mind),
            The Principle of Correspondence (As Above So Below), The Principle
            of Vibration (All Moves), The Principle of Polarity (Duality), The
            Principle of Rhythm (Cycles), The Principle of Cause and Effect
            (Action and Reaction) and The Principle of Gender (Masculine and
            Feminine) - the guiding principles that act as keys that help
            understand existence and the order that sustains the universe.
            Besides that, each episode will consistently feature aone of the 4
            phases and colors of alchemical transmutation: Nigredo/Blackening,
            Albedo/Whitening, Citrinas/Yellowing & Rubedo/Reddening - that show
            how color relates to transmutation, allowing us to understand the
            vitality of the current phase of the work. And, lastly, each episode
            will consistently feature one of the 8 alchemical operations –
            Calcinatio/Fire, Solutio/Water, Separatio/Separation,
            Conjuctio/Union, Mortifactio/Death, Rotatio/Time,
            Sublimatio/Evaporation & Coagulatio/Solidity - the center of the
            alchemist's work, the overriding principles that determine the story
            at hands.
          </p>
          <p class="animate fadeInLeft delay-1">
            The 8th episode is synonymous with the Philosophical Stone, the
            Magnum Opus, representing the magical possibilities that are
            possible after ingredients adhere and considerable soul awakening
            and spiritual integration have occurred. Now, completely aware that
            she is a character inside a story that her consciousness created, a
            new form of Patricia's consciousness is ready to be birthed and
            create a new story. In the last fragment of this episode, a wave
            crashes inside the room where all characters gather making the myth
            real and dissolving all fragments in the waters that clear and set
            the tone for the evolution of the next stage of her ascension. The
            Path then emerges from the water's foam in the company of her soul
            brother, taking the public through a real-life initiatory process
            that will fuse the realms of fiction and reality, changing the world
            as we know it.
          </p>

          <div class="film-details animate fadeInLeft delay-2">
            <div class="detail-section keywords-section">
              <h4>Keywords</h4>
              <p>
                <span>historical</span>
                <span>emotional</span>
                <span>epic</span>
                <span>enigmatic</span>
                <span>legendary</span>
                <span>brilliant</span>
                <span>layered</span>
                <span>visionary</span>
                <span>magical</span>
                <span>dramatic</span>
                <span>powerful</span>
                <span>provoking</span>
                <span>emotionally charged</span>
                <span>mystical</span>
                <span>dreamy</span>
                <span>anime</span>
                <span>adult animation</span>
                <span>atmospheric</span>
                <span>psychedelic</span>
                <span>philosophical</span>
                <span>cerebral</span>
                <span>raw</span>
                <span>intense</span>
                <span>honest</span>
                <span>passionate</span>
                <span>unusual plot structure</span>
                <span>allegorical</span>
                <span>poetic</span>
                <span>captivating</span>
                <span>visually stunning</span>
              </p>
            </div>
            <div class="detail-section">
              <h4>Themes</h4>
              <p>
                alchemy, transmutation, liberation, bloodlines, heritage, pain,
                trauma, death & resurrection, ancient mysteries, puzzles &
                riddles, pilgrimage, mission, divine love, tea ceremonies, past
                & multidimensional lives, love story, destined love, karma,
                dharma, siddhis, supernatural abilities, curses spells and
                rituals, imaginary, transformation, self-discovery, young woman,
                falling in love, twin flames, twin soul brother and sister,
                alternate reality, subconscious, quest, twists and turns,
                hermeticism, existentialism, fictional reality, mind control,
                master key, time, redemption, evolution, ascension, afterlife,
                reincarnation, dealing with death, life and death, mysterious
                character, love at first sight, long distance relationship,
                destiny.
              </p>
            </div>
            <div class="detail-section">
              <h4>Visual Style</h4>
              <p>
                This animated series will be hand-drawn, including all seasonal
                aesthetics and tones, rich in color, with vivid and attentive
                details of backgrounds and environments, creating richly crafted
                worlds. The emotional experience of the characters will be
                enhanced in the animation too, making it as close to live action
                film as possible and as emotionally raw as possible too. It is
                instrumental that spirits are touched and souls awaken by the
                way the spectator is brought into the experience on screen. Both
                protagonists will be drawn after Patricia's physical features
                and the mystery man's features so their incarnations are
                perceivable across cultures and timelines and so the transition
                between animation and live action film is as subtle as possible
                in the 8th episode.
              </p>
            </div>
            <div class="detail-section">
              <h4>Visual References</h4>
              <p>
                Films from Studio Ghibli – Spirited Away (2001), Princess
                Mononoke (1997), Howl's Moving Castle (2004), Castle In the Sky
                (1986), When Marnie Was There (2014), From Up On Poppy Hill
                (2011), Grave of the Fireflies (1988), The Boy and The Heron
                (2023), as well as their international co-production "The Red
                Turtle". Other references are Your Name (2016), Suzume (2022),
                Weathering With You (2019), Paprika (2006), Perfect Blue (1997),
                Millennium Actress (2001), Angel's Egg (1985).
              </p>
            </div>
          </div>
        </div>
        <div class="story-images">
          <div class="film1-gallery">
            <img
              v-for="(imgSrc, index) in collectionGallery"
              :key="`s1g-${index}`"
              :src="imgSrc"
              :alt="`The Child That Came From The East - Image ${index + 1}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <div class="film-quote-container">
          <div class="film-quote film-quote-thechild animate fadeIn delay-1">
            IT ALWAYS TAKES MANY STORIES TO TELL ONE STORY.
          </div>
        </div>
      </section>

      <!-- S1 Episodes -->
      <h3 class="bigText episodesHeading s1EpisodesHeading">The 8 Episodes</h3>
      <p class="text-center animate fadeInUp">
        The 8 episodes will evolve according to the 7 alchemical processes, the
        4 phases/colors of alchemical transmutation and psychological
        transformation and the 7 hermetic laws. Each episode will open with the
        linking key provided upon the end of the previous chapter, connecting
        all alchemical operations and timelines by similar events. This will
        grant us access to all parallel timelines, understanding the resonance
        and interactivity between all events and how their occurrence is not
        necessarily linear but parallel, possible depending on conscious choice,
        until we converge in the 8th episode, in the created universe of "What
        Takes Shape In the Middle of Nowhere" for a grand final that prepare us
        for a new beginning.
      </p>

      <div class="episodes-list text-center animate fadeInUp delay-1">
        <p><strong>EP1 - INDIA</strong> Amor Fati</p>
        <p><strong>EP2 - CHINA</strong> Prima Facie</p>
        <p><strong>EP3 - MOROCCO</strong> Momento Mori</p>
        <p><strong>EP4 - AVALON</strong> V.I.T.R.I.O.L.</p>
        <p><strong>EP5 - EGYPT</strong> Ex Oriente Lux</p>
        <p><strong>EP6 - JAPAN</strong> Ordo Ab Chao</p>
        <p><strong>EP7 - SOCOTRA</strong> Anima Mundi</p>
        <p><strong>EP8 - SCOTLAND</strong> Vita Somniu Breve</p>
      </div>

      <div class="season-block season-1">
        <div class="text-center see-more-container">
          <button
            @click="toggleEpisodes('S1')"
            class="see-more-btn animate fadeInUp"
          >
            {{ showEpisodesS1 ? "Show less" : "Show more" }}
          </button>
        </div>
        <transition
          name="height-expand"
          @before-enter="beforeEnter"
          @enter="enter"
          @before-leave="beforeLeave"
          @leave="leave"
        >
          <div v-if="showEpisodesS1" class="episodes-container">
            <!-- Loop through EACH ALCHEMICAL PHASE -->
            <template
              v-for="phase in alchemicalPhases"
              :key="`phase-${phase.id}`"
            >
              <!-- PHASE SEPARATOR -->
              <div
                class="alchemical-phase-separator"
                :class="`phase-${phase.name.toLowerCase()}`"
              >
                <h4 class="phase-title">{{ phase.displayName }}</h4>
                <p class="phase-description">{{ phase.description }}</p>
              </div>

              <!-- Episodes for this phase -->
              <template
                v-for="(episode, index) in getEpisodesByPhase(phase.name)"
                :key="`ep-${episode.id}`"
              >
                <div class="film-title-container">
                  <div class="circleNumber episode-circle">
                    {{ episode.id }}
                  </div>
                  <div class="episode-number animate fadeInDown grey">
                    Episode {{ episode.id }}
                  </div>
                  <h3 class="film-title episode-title serif animate fadeInDown">
                    <span class="brush-title">{{ episode.title }}</span>
                  </h3>
                  <p
                    v-if="episode.titleTranslation"
                    class="episode-translation grey animate fadeInDown"
                  >
                    " {{ episode.titleTranslation }} "
                  </p>
                  <p class="episode-subtitle serif">{{ episode.subtitle }}</p>
                  <div class="episode-principles animate fadeInDown delay-1">
                    <p class="diamond">♢</p>
                    <p class="operation-law">
                      {{ episode.alchemicalOperation }} ~
                      {{ episode.hermeticLaw }}
                    </p>
                  </div>
                </div>
                <div
                  class="story-section animate fadeIn episode-section"
                  :class="[
                    index % 2 === 0 ? 'story-right' : 'story-left',
                    `phase-${phase.name.toLowerCase()}-episode`,
                  ]"
                >
                  <div class="story-content">
                    <!-- Full text paragraphs -->
                    <p
                      v-for="(paragraph, pIndex) in episode.fullText"
                      :key="`ep${episode.id}-p${pIndex}`"
                      :class="
                        index % 2 === 0
                          ? 'animate fadeInLeft delay-1'
                          : 'animate fadeInRight delay-1'
                      "
                    >
                      {{ paragraph }}
                    </p>

                    <!-- Episode details -->
                    <div
                      :class="
                        index % 2 === 0
                          ? 'film-details animate fadeInLeft delay-2'
                          : 'film-details animate fadeInRight delay-2'
                      "
                    >
                      <div class="detail-section keywords-section">
                        <h4>Keywords</h4>
                        <p>
                          <span v-for="kw in episode.keywords" :key="kw">{{
                            kw
                          }}</span>
                        </p>
                      </div>
                      <div class="detail-section">
                        <h4>Themes</h4>
                        <p>{{ episode.themes }}</p>
                      </div>
                      <!-- <div class="detail-section">
                        <h4>Visual Style</h4>
                        <p>{{ episode.visualStyle }}</p>
                      </div>
                      <div class="detail-section">
                        <h4>Visual References</h4>
                        <p>{{ episode.visualReferences }}</p>
                      </div> -->
                    </div>

                    <!-- Closing Quote (if present) -->
                    <p
                      v-if="episode.closingQuote"
                      :class="[
                        'closing-quote',
                        index % 2 === 0
                          ? 'animate fadeInLeft delay-1'
                          : 'animate fadeInRight delay-1',
                      ]"
                    >
                      {{ episode.closingQuote }}
                    </p>
                  </div>
                  <div class="story-images">
                    <div :class="`episode-${episode.id}-gallery`">
                      <img
                        v-for="(img, imgIndex) in episode.images"
                        :key="`ep${episode.id}-img${imgIndex}`"
                        :src="img"
                        :alt="`${episode.title} - ${episode.subtitle} - Scene ${
                          imgIndex + 1
                        }`"
                        class="animate zoomIn"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </template>

            <div class="text-center see-more-container">
              <button
                @click="hideEpisodesAndScroll('S1')"
                class="see-more-btn animate fadeInUp"
              >
                Show less
              </button>
            </div>
          </div>
        </transition>
        <div class="kybalion-quote text-center animate fadeInUp delay-1">
          <p class="quote-text">
            "The Principles of Truth are Seven; he who knows these,
            understandingly, possesses the Magic Key before whose touch all the
            Doors of the Temple fly open."
          </p>
          <p class="quote-attribution">The Kybalion</p>
        </div>
      </div>

      <!-- Story 2: The Path - Season 1 -->
      <div class="film-title-container">
        <div class="circleNumber">2</div>
        <img
          :src="titles.thePathS1"
          alt="The Path S1"
          class="film-title film-title-thepaths1 animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-left animate fadeIn"
        data-theme-group="thepath"
      >
        <div class="story-content">
          <p class="animate fadeInRight delay-1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum
            in neque ante. Integer nec orci at nulla gravida imperdiet.
          </p>
          <p class="animate fadeInRight delay-1">
            Aenean bibendum ex in vulputate ullamcorper. Cras eu sapien non elit
            feugiat maximus. In feugiat, elit sed dictum tristique, velit justo
            accumsan eros, vitae commodo ipsum turpis nec turpis.
          </p>
          <div class="film-details animate fadeInRight delay-2">
            <div class="detail-section">
              <h4>Keywords</h4>
              <p>
                <span>hybrid</span>
                <span>non-fiction</span>
                <span>fiction</span>
                <span>convergence</span>
                <span>mirror</span>
              </p>
            </div>
          </div>
        </div>
        <div class="story-images">
          <div class="film2-gallery">
            <img
              v-for="n in 6"
              :key="`s2g-${n}`"
              :src="placeholder"
              :alt="`The Path S1 placeholder ${n}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <!--      <div class="film-quote-container">
          <div class="film-quote film-quote-thepaths1 animate fadeIn delay-1">
            When truth and story overlap, reality learns new names.
          </div> 
        </div> -->
      </section>

      <!-- S2 Episodes -->
      <h3 class="bigText episodesHeading s2EpisodesHeading">The 10 Episodes</h3>
      <p class="text-center animate FadeInUp">
        A hybrid exploration of crossings between what is lived and what is
        told.
      </p>
      <div class="season-block season-2">
        <div class="text-center see-more-container">
          <button
            @click="toggleEpisodes('S2')"
            class="see-more-btn animate fadeInUp"
          >
            {{ showEpisodesS2 ? "Show less" : "Show more" }}
          </button>
        </div>
        <transition
          name="height-expand"
          @before-enter="beforeEnter"
          @enter="enter"
          @before-leave="beforeLeave"
          @leave="leave"
        >
          <div v-if="showEpisodesS2" class="episodes-container">
            <template
              v-for="(episode, index) in episodesS2"
              :key="`s2-${episode.id}`"
            >
              <div class="film-title-container">
                <div class="circleNumber episode-circle">{{ episode.id }}</div>
                <div class="episode-number animate fadeInDown grey">
                  Episode {{ episode.id }}
                </div>
                <h3 class="film-title episode-title serif animate fadeInDown">
                  {{ episode.title }}
                </h3>
              </div>
              <div
                class="story-section animate fadeIn episode-section"
                :class="[
                  index % 2 === 0 ? 'story-right' : 'story-left',
                  index === episodesS2.length - 1 ? 'last-episode' : '',
                ]"
                data-theme-group="thepath"
              >
                <div class="story-content">
                  <p
                    :class="
                      index % 2 === 0
                        ? 'animate fadeInLeft delay-1'
                        : 'animate fadeInRight delay-1'
                    "
                  >
                    {{ episode.fullText }}
                  </p>
                  <div
                    :class="
                      index % 2 === 0
                        ? 'film-details animate fadeInLeft delay-2'
                        : 'film-details animate fadeInRight delay-2'
                    "
                  >
                    <div class="detail-section">
                      <h4>Keywords</h4>
                      <p>
                        <span v-for="kw in episode.keywords" :key="kw">{{
                          kw
                        }}</span>
                      </p>
                    </div>
                    <div class="detail-section">
                      <h4>Visual References</h4>
                      <p>{{ episode.visualReferences }}</p>
                    </div>
                  </div>
                </div>
                <div class="story-images">
                  <div :class="`episodeS2-${episode.id}-gallery`">
                    <img
                      v-for="(img, imgIndex) in episode.images"
                      :key="`s2-${episode.id}-${imgIndex}`"
                      :src="img"
                      :alt="`Episode ${episode.id} Scene ${imgIndex + 1}`"
                      class="animate zoomIn"
                    />
                  </div>
                </div>
              </div>
            </template>
            <div class="text-center see-more-container">
              <button
                @click="hideEpisodesAndScroll('S2')"
                class="see-more-btn animate fadeInUp"
              >
                Show less
              </button>
            </div>
          </div>
        </transition>
        <!-- Season 2 end sentence -->
        <!--         <div class="film-quote-container">
          <div class="film-quote film-quote-thepaths1 animate fadeIn delay-1">
            Every crossing leaves a trace for the next to follow.
          </div>
        </div> -->
      </div>

      <!-- Story 3: The Path - Season 2 -->
      <div class="film-title-container">
        <div class="circleNumber">3</div>
        <img
          :src="titles.thePathS2"
          alt="The Path S2"
          class="film-title film-title-thepaths2 animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-right animate fadeIn"
        data-theme-group="thepath"
      >
        <div class="story-content">
          <p class="animate fadeInLeft delay-1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Etiam
            ultrices ante nec mi blandit, vitae volutpat erat tincidunt.
          </p>
          <p class="animate fadeInLeft delay-1">
            Praesent vel lacinia magna. Integer posuere lorem ac lectus
            lobortis, sit amet tempor lorem aliquet. Vivamus vitae aliquam
            neque, a ullamcorper arcu.
          </p>
          <div class="film-details animate fadeInLeft delay-2">
            <div class="detail-section">
              <h4>Keywords</h4>
              <p>
                <span>sync</span>
                <span>expansion</span>
                <span>alignment</span>
                <span>echo</span>
                <span>integration</span>
              </p>
            </div>
          </div>
        </div>
        <div class="story-images">
          <div class="film3-gallery">
            <img
              v-for="n in 6"
              :key="`s3g-${n}`"
              :src="placeholder"
              :alt="`The Path S2 placeholder ${n}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <!--    <div class="film-quote-container">
          <div class="film-quote film-quote-thepaths2 animate fadeIn delay-1">
            The farther you go, the clearer the beginning becomes.
          </div>
        </div>-->
      </section>

      <!-- S3 Episodes -->
      <h3 class="bigText episodesHeading s3EpisodesHeading">The 10 Episodes</h3>
      <p class="text-center animate fadeInUp">
        Ten convergences — from many voices into one coherent signal.
      </p>
      <div class="season-block season-3">
        <div class="text-center see-more-container">
          <button
            @click="toggleEpisodes('S3')"
            class="see-more-btn animate fadeInUp"
          >
            {{ showEpisodesS3 ? "Show less" : "Show more" }}
          </button>
        </div>
        <transition
          name="height-expand"
          @before-enter="beforeEnter"
          @enter="enter"
          @before-leave="beforeLeave"
          @leave="leave"
        >
          <div v-if="showEpisodesS3" class="episodes-container">
            <template
              v-for="(episode, index) in episodesS3"
              :key="`s3-${episode.id}`"
            >
              <div class="film-title-container">
                <div class="circleNumber episode-circle">{{ episode.id }}</div>
                <div class="episode-number animate fadeInDown grey">
                  Episode {{ episode.id }}
                </div>
                <h3 class="film-title episode-title serif animate fadeInDown">
                  {{ episode.title }}
                </h3>
              </div>
              <div
                class="story-section animate fadeIn episode-section"
                :class="[
                  index % 2 === 0 ? 'story-right' : 'story-left',
                  index === episodesS3.length - 1 ? 'last-episode' : '',
                ]"
                data-theme-group="thepath"
              >
                <div class="story-content">
                  <p
                    :class="
                      index % 2 === 0
                        ? 'animate fadeInLeft delay-1'
                        : 'animate fadeInRight delay-1'
                    "
                  >
                    {{ episode.fullText }}
                  </p>
                  <div
                    :class="
                      index % 2 === 0
                        ? 'film-details animate fadeInLeft delay-2'
                        : 'film-details animate fadeInRight delay-2'
                    "
                  >
                    <div class="detail-section">
                      <h4>Keywords</h4>
                      <p>
                        <span v-for="kw in episode.keywords" :key="kw">{{
                          kw
                        }}</span>
                      </p>
                    </div>
                    <div class="detail-section">
                      <h4>Visual References</h4>
                      <p>{{ episode.visualReferences }}</p>
                    </div>
                  </div>
                </div>
                <div class="story-images">
                  <div :class="`episodeS3-${episode.id}-gallery`">
                    <img
                      v-for="(img, imgIndex) in episode.images"
                      :key="`s3-${episode.id}-${imgIndex}`"
                      :src="img"
                      :alt="`Episode ${episode.id} Scene ${imgIndex + 1}`"
                      class="animate zoomIn"
                    />
                  </div>
                </div>
              </div>
            </template>
            <div class="text-center see-more-container">
              <button
                @click="hideEpisodesAndScroll('S3')"
                class="see-more-btn animate fadeInUp"
              >
                Show less
              </button>
            </div>
          </div>
        </transition>
        <!-- Season 3 end sentence -->
        <!--   <div class="film-quote-container">
          <div class="film-quote film-quote-thepaths2 animate fadeIn delay-1">
            At the end of the road, you recognize the one who started walking.
          </div>
        </div> -->
      </div>

      <!-- Story 4: Deus Ex Machina (Live Theatre) -->
      <div class="film-title-container">
        <div class="circleNumber">4</div>
        <img
          :src="titles.deusEx"
          alt="Deus Ex Machina"
          class="film-title film-title-deusex animate fadeInDown"
        />
      </div>
      <section
        class="story-section story-left animate fadeIn"
        data-theme-group="thepath"
      >
        <div class="story-content">
          <p class="animate fadeInRight delay-1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris
            vehicula mi eu nunc finibus semper. Integer volutpat luctus nibh,
            nec faucibus eros efficitur sed.
          </p>
        </div>
        <div class="story-images">
          <div class="film4-gallery">
            <img
              v-for="n in 6"
              :key="`s4g-${n}`"
              :src="placeholder"
              :alt="`Deus Ex Machina placeholder ${n}`"
              class="animate zoomIn"
            />
          </div>
        </div>
        <div class="film-quote-container">
          <div class="film-quote film-quote-deusex animate fadeIn delay-1">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit.
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, ref, watch } from "vue";
import SwissStyleTable from "@/components/GenericComponents/SwissStyleTable.vue";
import useDynamicBackground from "@/composables/useDynamicBackground";
import thePathEpisodes, { alchemicalPhases } from "@/data/thePathEpisodes";
import MicroNDA from "@/components/GenericComponents/MicroNDA.vue";

export default defineComponent({
  name: "ThePathCharacter",
  components: {
    SwissStyleTable,
    MicroNDA,
  },
  setup() {
    // Assets
    const goldenBarbara = require("@/assets/images/barbara_3_gold.png");
    const placeholder = require("@/assets/images/Path/placeholder.gif");

    // About section images - 7 images from intake
    const pathAboutImages = [
      require("@/assets/images/Path/about_images/1.jpg"),
      require("@/assets/images/Path/about_images/2.jpg"),
      require("@/assets/images/Path/about_images/3.jpg"),
      require("@/assets/images/Path/about_images/4.jpg"),
      require("@/assets/images/Path/about_images/5.jpg"),
      require("@/assets/images/Path/about_images/6.jpg"),
      require("@/assets/images/Path/about_images/1_hor.jpg"),
    ];

    // Collection gallery images (all 28 for Story 1)
    const collectionGallery = [];
    for (let i = 1; i <= 28; i++) {
      collectionGallery.push(
        require(`@/assets/images/Path/collection1/${i}.jpg`)
      );
    }

    const titles = {
      theChild: require("@/assets/images/Path/titles/theChild.png"),
      thePathS1: placeholder,
      thePathS2: placeholder,
      deusEx: require("@/assets/images/Path/titles/deus_ex_machina.png"),
    };

    // Collections table
    const collectionsRows = [
      [
        ["THE CHILD THAT CAME FROM THE EAST", "Spring"],
        "Animation TV Series",
        { color: "var(--green)", text: "Written" },
      ],
      [
        ["THE PATH — Season 1", "Summer"],
        "Non Fiction & Fiction Hybrid TV Series",
        { color: "var(--green)", text: "Written" },
      ],
      [
        ["THE PATH — Season 2", "Fall"],
        "Non Fiction & Fiction Hybrid TV Series",
        { color: "var(--green)", text: "Written" },
      ],
      [
        ["DEUS EX MACHINA", "Winter"],
        "Live Theatre",
        { color: "var(--grey)", text: "Concept" },
      ],
    ];

    // Episodes - REAL DATA from thePathEpisodes.js
    const showEpisodesS1 = ref(false);
    const showEpisodesS2 = ref(false);
    const showEpisodesS3 = ref(false);

    const episodesS1 = ref(thePathEpisodes); // 8 real episodes
    const episodesS2 = ref([]); // Season 2 - placeholder for now
    const episodesS3 = ref([]); // Season 3 - placeholder for now

    // Helper to get episodes by phase
    const getEpisodesByPhase = (phaseName) => {
      return thePathEpisodes.filter((ep) => ep.phase === phaseName);
    };

    // Toggle helpers
    const toggleEpisodes = (season) => {
      if (season === "S1") showEpisodesS1.value = !showEpisodesS1.value;
      if (season === "S2") showEpisodesS2.value = !showEpisodesS2.value;
      if (season === "S3") showEpisodesS3.value = !showEpisodesS3.value;
    };

    const hideEpisodesAndScroll = (season) => {
      if (season === "S1") showEpisodesS1.value = false;
      if (season === "S2") showEpisodesS2.value = false;
      if (season === "S3") showEpisodesS3.value = false;

      setTimeout(() => {
        const selector =
          season === "S1"
            ? ".s1EpisodesHeading"
            : season === "S2"
            ? ".s2EpisodesHeading"
            : ".s3EpisodesHeading";
        const header = document.querySelector(selector);
        if (header) {
          header.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    };

    // Use the dynamic background composable
    const { currentVisibleSection, currentBodyClasses } =
      useDynamicBackground();

    // IntersectionObserver for .animate
    let observerInstance = null;
    const setupIntersectionObserver = () => {
      const observerOptions = {
        root: null,
        rootMargin: "0px 0px 0px 0px",
        threshold: 0.01,
      };
      const handleIntersection = (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) entry.target.classList.add("active");
          else entry.target.classList.remove("active");
        });
      };
      observerInstance = new IntersectionObserver(
        handleIntersection,
        observerOptions
      );
      const elements = document.querySelectorAll(".animate");
      elements.forEach((el) => {
        if (el) observerInstance.observe(el);
      });
    };

    // Transition hooks for height animation (episodes expand/collapse)
    const beforeEnter = (el) => {
      el.style.height = "0";
      el.style.overflow = "hidden";
      el.style.transition = "height 0.4s ease";
    };

    const enter = (el) => {
      // Trigger reflow
      el.offsetHeight; // eslint-disable-line no-unused-expressions
      const images = el.querySelectorAll("img");
      let loaded = 0;
      const total = images.length;
      const check = () => {
        el.style.height = el.scrollHeight + "px";
        setTimeout(() => {
          if (observerInstance) {
            const newEls = el.querySelectorAll(".animate");
            newEls.forEach((e) => observerInstance.observe(e));
          }
        }, 100);
      };
      if (total === 0) {
        check();
      } else {
        images.forEach((img) => {
          if (img.complete) {
            loaded++;
          } else {
            img.onload = img.onerror = () => {
              loaded++;
              if (loaded === total) check();
            };
          }
        });
        setTimeout(() => {
          if (loaded < total) check();
        }, 1000);
        if (loaded === total) check();
      }
    };

    const beforeLeave = (el) => {
      el.style.height = el.scrollHeight + "px";
      el.style.overflow = "hidden";
      el.style.transition = "height 0.4s ease";
    };

    const leave = (el) => {
      el.offsetHeight; // eslint-disable-line no-unused-expressions
      el.style.height = "0";
    };

    // Episodes-expanded -> request light theme in drawer for readability (match pattern from Patricia)
    const dispatchEpisodesExpanded = () => {
      const event = new CustomEvent("episodesExpanded", {
        detail: { themeGroup: "thepath" },
      });
      window.dispatchEvent(event);
    };

    // S1 (The Child That Came From The East) should NOT change background
    // Only S2 and S3 dispatch the event to change theme
    watch(showEpisodesS2, (v) => {
      if (v) dispatchEpisodesExpanded();
    });
    watch(showEpisodesS3, (v) => {
      if (v) dispatchEpisodesExpanded();
    });

    onMounted(() => {
      setupIntersectionObserver();
      // Drawer theme toggle listener (pattern parity)
      window.addEventListener("themeChange", (event) => {
        setTimeout(() => {
          const drawer = document.querySelector(".BottomDrawer");
          if (drawer) {
            if (event?.detail?.isLightTheme)
              drawer.classList.add("light-theme");
            else drawer.classList.remove("light-theme");
          }
        }, 100);
      });
    });

    return {
      goldenBarbara,
      placeholder,
      pathAboutImages,
      collectionGallery,
      titles,
      collectionsRows,
      episodesS1,
      episodesS2,
      episodesS3,
      alchemicalPhases,
      getEpisodesByPhase,
      showEpisodesS1,
      showEpisodesS2,
      showEpisodesS3,
      toggleEpisodes,
      hideEpisodesAndScroll,
      beforeEnter,
      enter,
      beforeLeave,
      leave,
      currentVisibleSection,
      currentBodyClasses,
    };
  },
});
</script>

<style scoped>
.thepath-container {
  max-width: 900px;
  margin: 0 auto;
  overflow-x: hidden;
  box-sizing: border-box;
  padding: var(--space) 0;
  width: 100%;
}

.headerImgText {
  max-height: 260px;
}

.headerQuote {
  width: 100%;
  align-items: flex-start !important;
  position: relative;
  height: 130px;
}
.headerQuote .line1 {
  position: absolute;
  top: 0;
  left: 0px;
  white-space: nowrap;
}
.headerQuote .line2 {
  position: absolute;
  left: -120px;
  white-space: nowrap;
  top: 40px;
}
.headerQuote .line3 {
  position: absolute;
  white-space: nowrap;
  bottom: -10px;
  right: 0;
}
.headerQuote .line4 {
  position: absolute;
  white-space: nowrap;
  bottom: -50px;
  right: 0;
}

.golden-image-container {
  position: relative;
  width: 100%;
  height: 60vh;
  max-height: 400px;
  margin: var(--doubleSpace) auto;
  overflow: visible;
}

.goldenBarbaraImage {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  width: auto;
  height: 100%;
  object-fit: contain;
  border-radius: var(--border-radius-medium);
  transition: opacity 0.3s ease;
}

/* Constrain images globally to avoid overflow on mobile (match refs) */
img {
  max-width: 100%;
  height: auto;
  border-radius: var(--border-radius-medium);
}

/* Intro spacing and title sizing (match refs) */
.intro-text {
  font-size: var(--smallFontSize);
  line-height: 1.4;
  margin-bottom: calc(var(--space) * 6.5);
}
.intro-text::after {
  content: "";
  position: absolute;
  top: calc(var(--regularFontSize) * 2);
  left: 50%;
  transform: translateX(-50%);
  width: 50px;
  height: 1px;
  background: var(--text-white);
}

.largest-TextMag {
  font-size: calc(var(--giganticFontSize) * 1.2) !important;
  font-weight: 630;
}

/* Film title images */
img.film-title-thechild {
  width: 60%;
  max-width: 320px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
  filter: brightness(1.08) saturate(0.9) sepia(0.12) hue-rotate(5deg)
    drop-shadow(0 0 6px rgba(255, 255, 200, 0.35))
    drop-shadow(0 0 12px rgba(255, 255, 200, 0.25));
}
img.film-title-thepaths1 {
  width: 60%;
  max-width: 360px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}
img.film-title-thepaths2 {
  width: 60%;
  max-width: 360px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}
img.film-title-deusex {
  width: 60%;
  max-width: 360px;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

.film-title-container {
  width: 100%;
  max-width: 900px;
  margin: calc(var(--doubleSpace) * 4) auto var(--doubleSpace) auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.film-title {
  width: 100%;
  margin: var(--space) 0 0 0;
  text-align: center;
  font-size: calc(var(--largerFontSize) * 1.8) !important;
}

/* Story layouts */
.story-section {
  margin-bottom: var(--doubleSpace);
  display: flex;
  flex-direction: column;
  gap: var(--space);
  max-width: 100%;
  box-sizing: border-box;
}

/* Consistent section spacing like refs */
.intro-section,
.collections-section,
.about-section,
.stories-section {
  margin-bottom: var(--doubleSpace);
}

/* Base image treatment (match Patricia/Cecilia) */
.story-images img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
}

.story-images img.animate {
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 0;
  transform: scale(0.95);
}
.story-images img.animate.active {
  opacity: 1;
  transform: scale(1);
}

/* Gallery layouts (match Cecilia) */
.film1-gallery,
.film2-gallery,
.film3-gallery,
.film4-gallery {
  display: flex;
  flex-direction: column;
  gap: var(--space);
  margin-top: var(--space);
}

/* Ensure transition also applies within galleries explicitly */
.film1-gallery img.animate,
.film2-gallery img.animate,
.film3-gallery img.animate,
.film4-gallery img.animate {
  transition: opacity 0.25s ease, transform 0.25s ease;
  opacity: 0;
  transform: scale(0.95);
}
.film1-gallery img.animate.active,
.film2-gallery img.animate.active,
.film3-gallery img.animate.active,
.film4-gallery img.animate.active {
  opacity: 1;
  transform: scale(1);
}

/* Episode galleries (match Patricia/Cecilia spacing) */
.episode-1-gallery,
.episode-2-gallery,
.episode-3-gallery,
.episode-4-gallery,
.episode-5-gallery,
.episode-6-gallery,
.episode-7-gallery,
.episode-8-gallery {
  display: flex;
  flex-direction: column;
  gap: var(--space);
  margin-top: var(--space);
}

.episode-1-gallery img,
.episode-2-gallery img,
.episode-3-gallery img,
.episode-4-gallery img,
.episode-5-gallery img,
.episode-6-gallery img,
.episode-7-gallery img,
.episode-8-gallery img {
  display: block;
  width: 100%;
  height: auto;
  object-fit: cover;
  border-radius: var(--border-radius-medium);
}

.film-quote-container {
  grid-column: 1 / -1;
  width: 100%;
  text-align: center;
  margin: var(--doubleSpace) auto;
}
.film-quote {
  margin: 0 auto;
  padding: var(--doubleSpace) var(--space);
  position: relative;
  border-left: none;
  width: 100%;
  box-sizing: border-box;
  font-size: calc(var(--regularFontSize) * 2.5);
}

.film-quote-thechild,
.film-quote-thepaths1,
.film-quote-thepaths2,
.film-quote-deusex {
  font-family: "RockSalt", "AlternateGotNo2D", sans-serif;
}

/* Yellow-white glossy gradient for The Child quote */
.film-quote-thechild {
  font-weight: bold;
  font-style: normal;
  text-align: center;
  background: linear-gradient(180deg, #ffffff 0%, #ffeb96 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  filter: drop-shadow(0 0 6px rgba(255, 255, 200, 0.35))
    drop-shadow(0 0 12px rgba(255, 255, 200, 0.25));
}

/* Kybalion Quote Styling */
.kybalion-quote {
  margin: calc(var(--doubleSpace) * 2) auto;
  padding: var(--largeSpace);
  max-width: 800px;
}

.kybalion-quote .quote-text {
  font-family: var(--serif);
  font-size: calc(var(--regularFontSize) * 1.4);
  font-style: italic;
  line-height: 1.8;
  margin-bottom: var(--space);
  opacity: 0.9;
}

.kybalion-quote .quote-attribution {
  font-family: var(--sans-serif);
  opacity: 0.7;

  font-size: var(--huge-text);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-top: var(--mediumSpace);
}

/* Detail sections */
.detail-section {
  margin-bottom: var(--space);
  margin-top: var(--bigSpace);
}
.detail-section h4 {
  font-size: var(--smallFontSize);
  color: var(--text-white);
  margin-bottom: var(--smallSpace);
  text-transform: uppercase;
  letter-spacing: 0.25em;
  font-weight: 250;
  opacity: 1;
}
.detail-section p {
  font-size: var(--smallFontSize);
  color: var(--grey-lighter);
  line-height: 1.6;
}

/* Keywords styling */
.keywords-section p,
.detail-section:first-child p {
  display: flex;
  flex-wrap: wrap;
  gap: var(--smallSpace);
}

.keywords-section p span,
.detail-section:first-child p span {
  display: inline-block;
  background: rgba(255, 255, 255, 0.1);
  color: var(--text-white);
  padding: 2px 8px;
  border: 1px solid var(--text-white);
  border-radius: var(--border-radius-pill);
  font-size: calc(var(--smallFontSize) * 0.9);
  font-weight: 220;
  margin-bottom: var(--smallSpace);
}

/* Episodes UI */
.episodesHeading {
  text-align: center;
  margin-top: calc(var(--doubleSpace) * 2);
  width: 100%;
}
.episodes-list {
  margin: var(--doubleSpace) auto;
  max-width: 600px;
  font-family: "Inter", system-ui, sans-serif;
}
.episodes-list p {
  margin: var(--space) 0;
  font-size: var(--regularFontSize);
  font-weight: 250;
  letter-spacing: 0.5px;
  line-height: 1.6;
}
.episodes-list strong {
  font-weight: 500;
  letter-spacing: 1px;
}
.circleNumber.episode-circle {
  position: absolute;
  opacity: 0;
}
.episode-number {
  text-transform: uppercase;
  letter-spacing: 3px;
  font-size: calc(var(--smallFontSize) * 0.8);
  border-top: 1px solid var(--border-light);
  padding: 30px;
}
.border-bottom {
  padding-bottom: calc(var(--doubleSpace) * 3);
  border-bottom: 1px solid var(--border-dark);
}
.season-block {
  padding-bottom: calc(var(--doubleSpace) * 3);
  border-bottom: 1px solid var(--border-dark);
  margin-bottom: calc(var(--doubleSpace) * 2);
}
.see-more-container {
  margin: var(--doubleSpace) 0;
}
.see-more-btn {
  height: var(--clickableHeight);
  border-radius: var(--border-radius-pill);
  border: 1px solid var(--text-white);
  background: transparent;
  color: var(--text-white);
  outline: none;
  cursor: pointer;
  transition: all var(--fastSpeed) ease;
  font-family: "Inter", system-ui, sans-serif;
  font-weight: 250;
  font-size: var(--regularFontSize);
  padding: var(--largeSpace);
  text-align: center;
  display: inline-flex;
  gap: var(--smallSpace);
  align-items: center;
}
.see-more-btn:hover {
  background-color: var(--grey-darkest);
}

body.light-theme .detail-section h4 {
  color: var(--text-light);
}
body.light-theme .keywords-section p span,
body.light-theme .detail-section:first-child p span {
  color: var(--text-light);
  border-color: var(--text-light);
}
body.light-theme .detail-section p {
  color: var(--text-light);
}
body.light-theme .see-more-btn {
  border-color: var(--text-light);
  color: var(--text-light);
}
body.light-theme .see-more-btn:hover {
  background-color: var(--grey-lighter);
}
body.light-theme .episodes-list p {
  color: var(--text-light);
}
body.light-theme .episodes-list strong {
  color: var(--text-light);
}
body.light-theme .kybalion-quote .quote-text {
  color: var(--text-light);
}
body.light-theme .kybalion-quote .quote-attribution {
  color: var(--text-light);
}

/* About section */
.about-content {
  display: flex;
  flex-direction: column;
  gap: var(--space);
}

.about-text {
  flex: 1;
}

.about-images {
  display: flex;
  flex-direction: column;
  gap: var(--space);
}

/* Responsive */
@media (min-width: 768px) {
  .thepath-container {
    padding: 0 var(--largeSpace);
    max-width: 900px;
    overflow: hidden;
    box-sizing: border-box;
  }
  .about-content {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    gap: var(--space);
  }
  .about-images {
    width: 40%;
  }

  .story-section {
    display: grid;
    align-items: flex-start;
    gap: var(--doubleSpace);
    width: 100%;
    max-width: 100%;
    margin: 0 auto;
    justify-content: space-between;
    box-sizing: border-box;
  }
  /* Explicit widths per layout to ensure text is always wider */
  .story-section.story-right {
    grid-template-columns: 62% 34%;
    grid-template-areas: "content images";
  }
  .story-section.story-left {
    grid-template-columns: 34% 62%;
    grid-template-areas: "images content";
  }
  .story-section.story-right .story-content {
    grid-area: content;
  }
  .story-section.story-right .story-images {
    grid-area: images;
  }
  .story-section.story-left .story-content {
    grid-area: content;
  }
  .story-section.story-left .story-images {
    grid-area: images;
  }
}

/* ========================================
   ALCHEMICAL PHASES - NEW CSS ONLY
   ======================================== */
.alchemical-phase-separator::before {
  content: "§";
  position: absolute;
  top: -15px;
  left: 50%;
  transform: translateX(-50%);
  width: 20px;
  /* height: 20px; */
  border-radius: var(--border-radius-pill);
  background: var(--text-main-dark);
  opacity: 1;
  color: var(--background-main);
  border: 4px solid var(--text-main-dark);
}

.alchemical-phase-separator {
  width: 100%;
  text-align: center;
  padding: var(--clickableHeight) 0 0 0;
  margin: var(--clickableHeight) 0;
  position: relative;
  border-top: 1px solid var(--text-main-dark);
}

/* Phase-specific separator colors matching phase titles */
.alchemical-phase-separator.phase-nigredo::before {
  background: var(--text-main-dark);
  border-color: var(--text-main-dark);
  color: #ffffff;
}

.alchemical-phase-separator.phase-nigredo {
  border-top-color: var(--text-main-dark);
}

.alchemical-phase-separator.phase-albedo::before {
  background: #ffffff;
  border-color: #ffffff;
  color: #000000;
}

.alchemical-phase-separator.phase-albedo {
  border-top-color: #ffffff;
}

.alchemical-phase-separator.phase-citrinitas::before {
  background: #ffd700;
  border-color: #ffd700;
  color: #000000;
}

.alchemical-phase-separator.phase-citrinitas {
  border-top-color: #ffd700;
}

.alchemical-phase-separator.phase-rubedo::before {
  background: #dc143c;
  border-color: #dc143c;
  color: #000000;
}

.alchemical-phase-separator.phase-rubedo {
  border-top-color: #dc143c;
}

/* Títulos das fases - DESTACADOS em cor */
.phase-title {
  font-size: var(--huge-text);
  letter-spacing: 0.15em;
  text-transform: uppercase;
  margin-top: var(--mediumSpace);
  font-family: var(--sans-serif);
}

/* Dark theme (default) - NIGREDO needs to be visible on dark background */
.phase-nigredo .phase-title {
  color: var(--text-main-dark);
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.3);
}

.phase-albedo .phase-title {
  color: #ffffff;
  text-shadow: 0 0 20px rgba(255, 255, 255, 0.8);
}

.phase-citrinitas .phase-title {
  color: #ffd700;
  text-shadow: 0 0 20px rgba(255, 215, 0, 0.6);
}

.phase-rubedo .phase-title {
  color: #dc143c;
  text-shadow: 0 0 20px rgba(220, 20, 60, 0.6);
}

/* Light theme - adjust colors for light background */
body.light-theme .phase-nigredo .phase-title {
  color: #000000;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.5);
}

body.light-theme .phase-albedo .phase-title {
  color: #666666;
  text-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
}

body.light-theme .phase-citrinitas .phase-title {
  color: #b8860b;
  text-shadow: 0 0 20px rgba(184, 134, 11, 0.6);
}

body.light-theme .phase-rubedo .phase-title {
  color: #8b0000;
  text-shadow: 0 0 20px rgba(139, 0, 0, 0.6);
}

.phase-description {
  font-size: var(--base-text);
  font-style: italic;
  opacity: 0.8;
  font-family: var(--serif);
}

.episode-translation {
  text-align: center;
  font-size: var(--regularFontSize);
  font-style: italic;
  margin-top: 0;
  opacity: 0.7;
}

.episode-subtitle {
  text-align: center;
  margin-top: var(--smallSpace) 0 0 0;
  letter-spacing: 0.15em;
  text-transform: uppercase;
}

.episode-principles {
  text-align: center;
  margin-bottom: var(--doubleSpace);
}

.episode-principles .diamond {
  margin: 0;
  opacity: 0.6;
  line-height: 2.5;
}

.episode-principles .operation-law {
  font-size: var(--smallFontSize);
  letter-spacing: 0.2em;
  text-transform: uppercase;
  margin: var(--smallSpace) 0 0 0;
  opacity: 0.8;
}

/* ======================================== */

@media (max-width: 767px) {
  .largest-TextMag {
    font-size: calc(var(--giganticFontSize) * 0.9) !important;
  }

  .golden-image-container {
    height: 30vh;
    max-height: 200px;
  }
  /* Ensure about images don't cause horizontal scroll */
  .about-images {
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: var(--space);
  }
  .about-content {
    overflow-x: hidden;
  }
  .about-section {
    overflow-x: visible;
  }

  /* Prevent header quote negative offset causing scroll on small screens */
  .headerQuote {
    transform: translateY(-50px);
  }

  .line1 h2,
  .line2 h2,
  .line3 h2,
  .line4 h2 {
    font-size: var(--largerFontSize) !important;
  }

  .headerQuote .line1 {
    top: 0;
    left: -100%;
  }
  .headerQuote .line2 {
    left: -190px;
    top: 40px;
  }
  .headerQuote .line3 {
    bottom: -60px;
  }
  .headerQuote .line4 {
    bottom: -100px;
  }
  .story-section.story-left {
    display: flex;
    flex-direction: column;
  }
  .story-section.story-left .story-content {
    order: 1;
  }
  .story-section.story-left .story-images {
    order: 2;
  }
  .story-section > .film-quote-container {
    order: 3;
  }
  .film-title-container {
    margin: calc(var(--doubleSpace) * 3) auto var(--largeSpace) auto;
    text-align: center;
  }
  .film-title {
    margin: var(--space) 0 var(--space) 0;
    font-size: calc(var(--largerFontSize) * 1.9) !important;
  }
  .film-quote {
    font-size: calc(var(--regularFontSize) * 2.5);
  }
  .animate {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
  .animate.active {
    opacity: 1;
  }
}

/* Closing Quote Styling */
.closing-quote {
  font-family: "Inter", sans-serif;
  font-weight: 100;
  text-align: right;
  width: 100%;
  font-size: var(--bigFontSize);
  line-height: normal;
  position: relative;
  margin: calc(var(--doubleSpace) * 3) 0;
}

.closing-quote::before {
  content: "\201C";
  font-size: calc(var(--biggerFontSize) * 1.5);
  transform: translate(-25px, -20px);
  position: absolute;
}
</style>
